import { ThemeModes } from '@themes/enums';
import * as appActions from './actions';
import { ActionType, getType } from 'typesafe-actions';
import { getFromLocalStorage, setToLocalStorage } from '@utils/localStorage';
import { THEME_MODE_LS_KEY } from '@mainConstants';

type AppActionType = ActionType<typeof appActions>;

export type AppState = {
  themeMode: ThemeModes;
};

const initialState: AppState = {
  themeMode: getFromLocalStorage(THEME_MODE_LS_KEY, ThemeModes.light),
};

const appReducer = (
  state: AppState = initialState,
  action: AppActionType,
): AppState => {
  switch (action.type) {
    case getType(appActions.setThemeMode):
      setToLocalStorage(THEME_MODE_LS_KEY, action.payload.mode);

      return {
        ...state,
        themeMode: action.payload.mode,
      };
    default:
      return state;
  }
};

export default appReducer;
